import React from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import { ArrowLeft, RefreshCw } from "lucide-react";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-display text-2xl text-[#F5F2EE] mb-3">{title}</h2>
    <div className="text-[#DCD7D2] text-sm leading-relaxed space-y-3">{children}</div>
  </section>
);

const Refunds = () => (
  <div className="min-h-screen bg-[#0C0E12]" data-testid="refunds-page">
    <SiteHeader />
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-[#A29F9B] hover:text-[#C5A880] mb-8">
        <ArrowLeft className="w-4 h-4" /> Voltar
      </Link>
      <div className="flex items-center gap-2 mb-3">
        <RefreshCw className="w-4 h-4 text-[#C5A880]" />
        <span className="label-uppercase">Política</span>
      </div>
      <h1 className="font-display text-4xl md:text-5xl mb-2">Política de Reembolso</h1>
      <p className="text-[#A29F9B] mb-10">Última atualização: 28 de Abril de 2026</p>

      <Section title="Princípio">
        <p>
          A Solfut, Lda quer que estejas satisfeito com o serviço Soulmatch. Se algo correr mal, fala connosco —
          em <a className="text-[#C5A880] hover:underline" href="mailto:servico-clientes@solfut.com">servico-clientes@solfut.com</a>
          {" "}ou +351 224 053 270 — e procuraremos a solução mais justa para ambos.
        </p>
      </Section>

      <Section title="1. Reembolso de cortesia (14 dias)">
        <p>
          Embora os serviços digitais possam ficar excluídos do direito de livre resolução nos termos do
          art.º 17º, nº 1, alínea m) do <strong>Decreto-Lei nº 24/2014</strong>, a Solfut adopta uma política
          de cortesia: <strong>reembolso integral em até 14 dias</strong> após a primeira subscrição,
          desde que <strong>não tenhas usado funcionalidades Premium</strong> que impliquem custo para a Solfut
          (análise IA do par, pesquisa pública RGPD-compliant Tavily, ver "quem deu like").
        </p>
        <p>
          Se já tiveres usado essas funcionalidades, oferecemos um <strong>reembolso parcial proporcional</strong>
          aos dias não consumidos da subscrição, descontados os custos directos com terceiros (comissão EuPago + Tavily/Anthropic).
        </p>
      </Section>

      <Section title="2. Renovação não desejada">
        <p>
          Os planos são compras únicas <strong>sem renovação automática</strong>. Não cobramos sem o teu pedido explícito.
          Caso, por erro técnico, sejas cobrado em duplicado, devolvemos integralmente em até <strong>5 dias úteis</strong>.
        </p>
      </Section>

      <Section title="3. Banimento por violação dos Termos">
        <p>
          Em caso de suspensão da conta por violação dos <Link to="/termos" className="text-[#C5A880] hover:underline">Termos e Condições</Link>
          {" "}(comportamento abusivo, fraude, falsidade da identidade), a subscrição não é reembolsada.
        </p>
      </Section>

      <Section title="4. Como pedir o reembolso">
        <ol className="list-decimal pl-5 space-y-2">
          <li>Envia email para <a className="text-[#C5A880] hover:underline" href="mailto:servico-clientes@solfut.com">servico-clientes@solfut.com</a> com o assunto <em>"Reembolso Soulmatch"</em>.</li>
          <li>Inclui o teu email da conta + nº da fatura (consulta em <Link to="/faturacao" className="text-[#C5A880] hover:underline">"Faturação"</Link>).</li>
          <li>Indica o motivo brevemente — não precisas de justificar nos 14 dias de cortesia.</li>
          <li>Resposta em <strong>3 dias úteis</strong>. Se aprovado, o reembolso é processado pela EuPago na conta original em <strong>5–10 dias úteis</strong>.</li>
        </ol>
      </Section>

      <Section title="5. Notas de crédito">
        <p>
          Sempre que houver reembolso, é emitida uma <strong>nota de crédito Moloni</strong> a anular total ou parcialmente
          a Fatura original. Disponível em "Faturação".
        </p>
      </Section>

      <Section title="6. Conflitos">
        <p>
          Em caso de discordância sobre um reembolso, podes recorrer ao <strong>CNIACC</strong>
          {" "}(<a className="text-[#C5A880] hover:underline" href="https://www.cniacc.pt" target="_blank" rel="noopener noreferrer">www.cniacc.pt</a>).
          Foro competente: Comarca do Porto.
        </p>
      </Section>

      <p className="text-xs text-[#A29F9B] mt-12 pt-6 border-t border-white/5">
        © 2026 Solfut, Lda · Versão 1.0 · 28-04-2026
      </p>
    </main>
    <Footer />
    </div>
);

export default Refunds;
